// extracted by mini-css-extract-plugin
module.exports = {"news":"Index_news_3en1t"};